module.exports = __webpack_public_path__ + "static/media/gh.57a76774.svg";